/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import { } from "vuex";
import axios from 'axios';
import router from '../router';
import store from '../store/index';
import { setStore } from '../config/mUtils'
import mutations from '../store/mutations'
import shopkeeper from '../service/shopkeeper';
import qs from 'qs';
import { Toast } from 'mint-ui';

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
    Toast('网络状态码:' + status + ',请重试！');
}

// 创建axios实例
var instance = axios.create({ timeout: 4000 * 12 });

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
    config => {
        let token = localStorage.getItem('token');
        let userName = localStorage.getItem('userName');
        let userFromType = localStorage.getItem('userFromType');
        let login = '?token=' + token + '&userName=' + userName + '&userFromType=' + userFromType; 
        if (config.url.indexOf('mobile/ymPoints.php') != -1 || 
        config.url.indexOf('qrcode.php') != -1 || 
        config.url.indexOf('mobile/invoice.php') != -1 || 
        config.url.indexOf('mobile/mystaff.php') != -1 ||
        config.url.indexOf('getInfoById') != -1) {
            config.data = qs.stringify({
                ...config.data
            })
        } else {
            config.url = config.url + login;
        }
        //const token = store.state.token;
        //token && (config.headers.Authorization = token);
        return config;
    },
    error => Promise.error(error)
)

// 响应拦截器
instance.interceptors.response.use(
    // 请求成功
    res => res.status === 200 ? Promise.resolve(res) : Promise.reject(res),
    // 请求失败
    async error => {
        if (error.response) {
            // 401的时候需要重新登录获取token
            if (error.response.status === 401) {
                let paramss = {
                    storeCode: store.state.storeCode,
                    userName: store.state.memberCode,
                    openId: store.state.openId,
                    appId: 1,
                    userFromType: 1,
                };
                // 清空token
                window.localStorage.removeItem('token');
                window.localStorage.removeItem('userName');
                window.localStorage.removeItem('userFromType');

               let res = await shopkeeper.login(paramss);
               let login = res.data.result
                if (login == null) {
                    // 跳转到登录页面
                    router.push({
                        path: '/home',
                        query: {
                            openid: store.state.openId,
                            mobile: store.state.mobile,
                            nickname: store.state.nickname,
                            storecode: store.state.storecode,
                            unionid: store.state.unionid
                        }
                    })
                    errorHandle(error.response.status, error.response.data);
                    // 路由跳转不过去，强制刷新页面了
                    window.location.reload();
                    return Promise.reject(error.response);
                }
                // 保存token
                setStore('token', login.token);
                // 保存用户名
                setStore('userName', login.userName);
                setStore('userFromType', 1);
                // 重新请求数据
                error.config.headers.Authorization = 'Bearer ' + login.token;

                let tempUrl = error.config.url;
                // 替换下url里面的token等信息
                let splitIndex = tempUrl.indexOf("?");
                tempUrl = tempUrl.substring(0, splitIndex);
                let tempParam = '?token=' + login.token + '&userName=' + login.userName + '&userFromType=' + 1;

                tempUrl += tempParam;
                error.config.url = tempUrl;
                return axios(error.config)
            } else {
                errorHandle(error.response.status, error.response.data);
                return Promise.reject(error.response);
            }
        } else {
            // 处理断网的情况
            Toast(error);
        }
    });

export default instance;



// WEBPACK FOOTER //
// ./src/common/axios.js